import React, {useEffect, useRef, useState} from 'react';
import {useHistory, Link} from 'react-router-dom';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import {SmallBox} from "@components";
import {useTranslation} from "react-i18next";
import {checkRole} from "@app/services/mainService";
import * as dashboardService from "@app/services/dashboardService";
import {formatCurencyVI} from "@app/utils/CommonFunctions";
import {image_root} from "@app/const/AppSetting";
import {useDispatch, useSelector} from "react-redux";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);
export const options = {
    responsive: true,
    plugins: {
        legend: {
            display: false
        }
    },
};

const labels =  ['Thứ hai', 'Thứ ba', 'Thứ tư', 'Thứ năm', 'OCT', 'NOV', 'DEC'];

export const data = {

    labels,
    datasets: [
        {
            backgroundColor: '#007bff',
            borderColor: '#007bff',
            data: [1757560000, 1457560000, 1157560000, 2057560000, 1857560000, 2457560000, 3217560000]
        },
        {
            backgroundColor: '#ced4da',
            borderColor: '#ced4da',
            data: [1357560000, 1157560000, 557560000, 1157560000, 1850560000, 2057560000, 2057560000]
        }
    ],
};


const Dashboard = () => {

    const [loading, setLoading] = useState(false);

    const [t] = useTranslation();

    const [thongkedashboard01, setThongkedashboard01] = useState({});
    const [dataTuan, setDataTuan] = useState(data);
    const [totalTuan, setTotalTuan] = useState(0);
    const [rsSanpham, setRsSanpham] = useState([]);
    const history = useHistory();
    const userTmp =  localStorage.getItem("profile");
    let user = useSelector((state) => state.auth.currentUser);
    if(userTmp )
        user = JSON.parse(userTmp);


    useEffect(async () => {
        const rs1 = await dashboardService.thongkedaohuunhadan();
        if(rs1 )
        {
            setThongkedashboard01(rs1);
        }

       /* const rs1 = await dashboardService.thongkebenhnhanvaphienkham();
        if(rs1 )
        {
            setThongkebenhnhanvaphienkham(rs1);
        }
        const rs2 = await dashboardService.thongkedoanhsongaytrongtuan();

        const rs3 = await dashboardService.thongketopdoanhnam();
        setRsSanpham(rs3);
        //setLabelTuan(Object.keys(rs2))
        setDataTuan({
            labels:Object.keys(rs2),
            datasets: [
                {
                    backgroundColor: '#007bff',
                    borderColor: '#007bff',
                    data:  ImportData(rs2)
                }
            ],
        });*/
    }, []);

    function ImportData(data)
    {
        let total = 0;
        let val = [];
        Object.keys(data).forEach(key => {
            val.push(data[key])
            total += data[key];
        });
        setTotalTuan(total);
        return val;
    }

    if (loading) {
        return (
            <div className="flex justify-center items-center h-40">
                <ClipLoader color="#3498db" size={50} />
            </div>
        );
    }
    return (
        <div className="container-fluid">
            { user.isadmin === "1" && (
                <div className="row">
                    <div className="col-lg-3 col-6">
                        <SmallBox
                            count={thongkedashboard01.numkhachhang}
                            title="Số lượng khách hàng trên hệ thống"
                            type="info"
                            icon="ion-android-people"
                            navigateTo="/khachhang"
                        />
                    </div>
                    <div className="col-lg-3 col-6">
                        <SmallBox
                            count={thongkedashboard01.numdonhang}
                            title="Số lượng đơn trên hệ thống"
                            type="danger"
                            icon="ion ion-bag"
                            navigateTo="/donhang"
                        />
                    </div>
                    <div className="col-lg-3 col-6">
                        <SmallBox
                            count={thongkedashboard01.numkhachhangtrongthang}
                            title="Số lượng khách phát sinh trong tháng"
                            icon="ion ion-person-add"
                            type="success"
                            navigateTo="/khachhang"
                        />
                    </div>
                    <div className="col-lg-3 col-6">
                        <SmallBox
                            count={thongkedashboard01.numdonhangtrongthang}
                            title="Số lượng đơn phát sinh trong tháng"
                            icon="ion ion-bag"
                            type="success"
                            navigateTo="/donhang"
                        />
                    </div>
                    <div className="col-lg-3 col-6">
                        <SmallBox
                            count={thongkedashboard01.numdonhangdangxuly}
                            title="Số lượng đơn Chờ xử lý"
                            icon="ion ion-bag"
                            type="warning"
                            navigateTo="/donhang"
                        />
                    </div>
                    <div className="col-lg-3 col-6">
                        <SmallBox
                            count={thongkedashboard01.numdonhangxulycadcam}
                            title="Số lượng đơn Đang xử lý cad/cam"
                            icon="ion ion-bag"
                            type="warning"
                            navigateTo="/donhang"
                        />
                    </div>
                    <div className="col-lg-3 col-6">
                        <SmallBox
                            count={thongkedashboard01.numdonhangxulycuadai}
                            title="Số lượng đơn Đang xử lý cưa đai"
                            icon="ion ion-bag"
                            type="warning"
                            navigateTo="/donhang"
                        />
                    </div>
                    <div className="col-lg-3 col-6">
                        <SmallBox
                            count={thongkedashboard01.numdonhangxulysap}
                            title="Số lượng đơn Đang xử lý sáp"
                            icon="ion ion-bag"
                            type="warning"
                            navigateTo="/donhang"
                        />
                    </div>
                    <div className="col-lg-3 col-6">
                        <SmallBox
                            count={thongkedashboard01.numdonhangxulysuon}
                            title="Số lượng đơn Đang xử lý sườn"
                            icon="ion ion-bag"
                            type="warning"
                            navigateTo="/donhang"
                        />
                    </div>
                    <div className="col-lg-3 col-6">
                        <SmallBox
                            count={thongkedashboard01.numdonhangxulydap}
                            title="Số lượng đơn Đang xử lý đắp"
                            icon="ion ion-bag"
                            type="warning"
                            navigateTo="/donhang"
                        />
                    </div>
                    <div className="col-lg-3 col-6">
                        <SmallBox
                            count={thongkedashboard01.numdonhangxulymai}
                            title="Số lượng đơn Đang xử lý mài"
                            icon="ion ion-bag"
                            type="warning"
                            navigateTo="/donhang"
                        />
                    </div>
                    <div className="col-lg-3 col-6">
                        <SmallBox
                            count={thongkedashboard01.numdonhangdanggiao}
                            title="Số lượng đơn Đang giao"
                            icon="fas fa-truck"
                            type="warning"
                            navigateTo="/donhang"
                        />
                    </div>
                    <div className="col-lg-3 col-6">
                        <SmallBox
                            count={thongkedashboard01.numdonhangdagiao}
                            title="Số lượng đơn Đã giao"
                            icon="fas fa-check-square"
                            type="success"
                            navigateTo="/donhang"
                        />
                    </div>
                    <div className="col-lg-3 col-6">
                        <SmallBox
                            count={thongkedashboard01.numdonhanglammoitrongthang}
                            title="Số đơn làm mới trong tháng"
                            icon="fas fa-plus"
                            type="success"
                            navigateTo="/donhang"
                        />
                    </div>
                    <div className="col-lg-3 col-6">
                        <SmallBox
                            count={thongkedashboard01.numdonhanglamlaitrongthang}
                            title="Số đơn làm lại trong tháng"
                            icon="fas fa-undo"
                            type="success"
                            navigateTo="/donhang"
                        />
                    </div>
                    <div className="col-lg-3 col-6">
                        <SmallBox
                            count={thongkedashboard01.numdonhangbaohanhtrongthang}
                            title="Số đơn bảo hành trong tháng"
                            icon="fas fa-tools"
                            type="success"
                            navigateTo="/donhang"
                        />
                    </div>
                    <div className="col-lg-3 col-6">
                        <SmallBox
                            count={thongkedashboard01.numsorangdalamtrongthang}
                            title="Số răng đã làm trong tháng"
                            icon="fas fa-tooth"
                            type="success"
                            navigateTo="/donhang"
                        />
                    </div>
                </div>
            )}
            { user.isadmin !=="1" && user.nhomnhanvien_fk !== "" && (
                <div className="row">
                    {/*<div className="col-lg-3 col-6">
                        <SmallBox
                            count={thongkedashboard01.numsorangdalamtrongthang}
                            title="Số răng đã làm trong tháng"
                            icon="fas fa-tooth"
                            type="success"
                            navigateTo="/donhang"
                        />
                    </div>*/}
                    { user.nhomnhanvien_fk === "1" && (
                        <>
                            <div className="col-lg-3 col-6">
                                <SmallBox
                                    count={thongkedashboard01.numdonhangdangxuly}
                                    title="Số lượng đơn Chờ xử lý"
                                    icon="ion ion-bag"
                                    type="warning"
                                    navigateTo="/donhang"
                                />
                            </div>
                            <div className="col-lg-3 col-6">
                                <SmallBox
                                    count={thongkedashboard01.numdonhangdanggiao}
                                    title="Số lượng đơn Đang giao"
                                    icon="fas fa-truck"
                                    type="warning"
                                    navigateTo="/donhang"
                                />
                            </div>
                        </>
                    )}
                    { (user.nhomnhanvien_fk === "2" || user.nhomnhanvien_fk === "1") && (
                        <div className="col-lg-3 col-6">
                            <SmallBox
                                count={thongkedashboard01.numdonhangxulycadcam}
                                title="Số lượng đơn Đang xử lý cad/cam"
                                icon="ion ion-bag"
                                type="warning"
                                navigateTo="/donhang"
                            />
                        </div>
                    )}
                    { (user.nhomnhanvien_fk === "3" || user.nhomnhanvien_fk === "1") && (
                        <div className="col-lg-3 col-6">
                            <SmallBox
                                count={thongkedashboard01.numdonhangxulycuadai}
                                title="Số lượng đơn Đang xử lý cưa đai"
                                icon="ion ion-bag"
                                type="warning"
                                navigateTo="/donhang"
                            />
                        </div>
                    )}
                    { (user.nhomnhanvien_fk === "4" || user.nhomnhanvien_fk === "1") && (
                        <div className="col-lg-3 col-6">
                            <SmallBox
                                count={thongkedashboard01.numdonhangxulysap}
                                title="Số lượng đơn Đang xử lý sáp"
                                icon="ion ion-bag"
                                type="warning"
                                navigateTo="/donhang"
                            />
                        </div>

                    )}
                    { (user.nhomnhanvien_fk === "8" || user.nhomnhanvien_fk === "1") && (
                        <div className="col-lg-3 col-6">
                            <SmallBox
                                count={thongkedashboard01.numdonhangxulysuon}
                                title="Số lượng đơn Đang xử lý sườn"
                                icon="ion ion-bag"
                                type="warning"
                                navigateTo="/donhang"
                            />
                        </div>

                    )}
                    { (user.nhomnhanvien_fk === "5" || user.nhomnhanvien_fk === "1") && (
                        <div className="col-lg-3 col-6">
                            <SmallBox
                                count={thongkedashboard01.numdonhangxulydap}
                                title="Số lượng đơn Đang xử lý đắp"
                                icon="ion ion-bag"
                                type="warning"
                                navigateTo="/donhang"
                            />
                        </div>

                    )}
                    { (user.nhomnhanvien_fk === "6" || user.nhomnhanvien_fk === "1") && (
                        <div className="col-lg-3 col-6">
                            <SmallBox
                                count={thongkedashboard01.numdonhangxulymai}
                                title="Số lượng đơn Đang xử lý mài"
                                icon="ion ion-bag"
                                type="warning"
                                navigateTo="/donhang"
                            />
                        </div>
                    )}

                </div>
            )}




        </div>
    );
};

export default Dashboard;
